import styled from "styled-components";
import {Message} from "primereact/message";
import {DataTable} from "primereact/datatable";

export const AddNewCategoryForm = styled.form`
    width: 500px;
`;

export const MessageAlignLeft = styled(Message)`
    justify-content: left;
`;

export const DataTableToolbar = styled.div`
    padding: 10px 0;
    min-height: 40px;
    text-align: right;
`;

export const DataTableWithColoredNewRow = styled(DataTable)`
    .coloredRow {
        background-color: #e5fbe5;
    }
`;

export const EnableDisableLabel = styled.label`
    margin-left: 10px;
`;